export interface TicketSource {
  ticketSourceId: string;
  ticketSourceName: string;
  baseUrl: string;
}
